import React from "react"
import Container from "../../Container"
import ImageWrapper from "../../ImageWrapper"
import Section from "../../Section"
import TextWrapper from "../../TextWrapper"
import { ListItem, UnorderedList } from "../../UnorderedLists"
import CheckMark from "../../../../images/home/check.svg"
import IconHeadingTitle from "../../IconHeadingTitle"
import offerPowerfulActionsData from "../../../../data/pageSections/platform/offers/offerPowerfulActions"

const OfferPowerfulActions = () => {
  const {
    titleIcon,
    title,
    description,
    graphic,
    imageLeft,
    benefits,
    clipPath,
    tint,
    textLong,
  } = offerPowerfulActionsData

  return (
    <Section tint={tint} clipPath={clipPath} className="padding-tb-0">
      <Container>
        <TextWrapper imageLeft={imageLeft} long={textLong}>
          <IconHeadingTitle icon={titleIcon} title={title} />
          {description}
          <UnorderedList>
            {benefits &&
              benefits.map(({ benefitName }) => (
                <ListItem>
                  <img
                    className="margin-right-10"
                    src={CheckMark}
                    alt="check"
                    title="check"
                  />
                  {benefitName}
                </ListItem>
              ))}
          </UnorderedList>
        </TextWrapper>
        <ImageWrapper imageLeft={imageLeft} short={textLong}>
          {graphic}
        </ImageWrapper>
      </Container>
    </Section>
  )
}

export default OfferPowerfulActions
